export enum Orientation {
    PORTRAIT = 'PORTRAIT',
    LANDSCAPE = 'LANDSCAPE'
}

export interface GridConfiguration {
    width: number;
    height: number;
    orientation: Orientation;
    showGridHelper: boolean;
    gridHelperColor: string;
    showGridAxis: boolean;
    gridAxisColor: string;
}

export interface PointConfiguration {
    radius: number;
    margin: number;
}

export interface LineConfiguration {
    continueLine: boolean
}

export interface AutoSaveConfiguration {
    active: boolean;
    timeInterval: number;
}

export interface SavingConfiguration {
    autoSave: AutoSaveConfiguration;
    saveOnExit: boolean;
}

export interface TrinketSettings {
    grid: GridConfiguration;
    point: PointConfiguration
    line: LineConfiguration
    saving: SavingConfiguration;
}
